<template>
  <div class="custom-checkbox-wrapper flex align-center">
    <input
      type="checkbox"
      ref="checkboxInput"
      class="custom-checkbox__input"
      :id="checkboxId"
      :checked="checked"
      :disabled="disabled"
      @change="toggle"
      v-on="$listeners"
    />
    <label :for="checkboxId" class="custom-checkbox__label">
      <slot></slot>
    </label>
  </div>
</template>

<script>
import { customCheckbox } from '@/shared/lib/form';

export default {
  mixins: [ customCheckbox ],
};
</script>

<style lang="scss" scoped>
.custom-checkbox-wrapper {
  display: flex;
  align-items: center;
}

.custom-checkbox__input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}

.custom-checkbox__label {
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  padding-left: 37px;
  user-select: none;
  min-height: 24px;
  line-height: 1.2;
  font-size: 16px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    border: 1px solid #0A77FF;
    border-radius: 50%;
    background-color: #fff;
    transition: all 0.2s ease-in-out;
    flex-shrink: 0;
  }

  &::after {
    content: '';
    position: absolute;
    left: 9px;
    top: 46%;
    transform: translateY(-50%) rotate(45deg);
    width: 6px;
    height: 12px;
    border: solid #0A77FF;
    border-width: 0 2px 2px 0;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }
}

.custom-checkbox__input:checked + .custom-checkbox__label {
  &::before {
    background-color: #0A77FF;
    border-color: #0A77FF;
  }

  &::after {
    opacity: 1;
    border-color: #ffffff;
  }
}

.custom-checkbox__input:indeterminate + .custom-checkbox__label {
  &::before {
    background-color: #9E9E9E;
    border-color: #9E9E9E;
  }
}
</style>
